// export const BASE_URL_API = "https://cors-anywhere.herokuapp.com/https://lokaci.com/aphrodite/web/apis";
export const BASE_URL_API = "https://lokaci.com/aphrodite/web/apis";